import React, { Component, Fragment } from 'react';

import PropTypes from 'prop-types';
import { MinusCircleOutlined } from '@ant-design/icons';
import { Radio, Select, Tooltip, Checkbox } from 'antd';

const { Option } = Select;

export class CustomField extends Component {
    static propTypes = {
        selectedId: PropTypes.object,
        userInput: PropTypes.bool,
        required: PropTypes.bool.isRequired,
        setSelected: PropTypes.func.isRequired,
        setRequired: PropTypes.func.isRequired,
        delete: PropTypes.func.isRequired,
        allCustomFields: PropTypes.object.isRequired
    };
    state = {
        showCustomFieldsTooltip: false
    };

    render() {
        return (
            <Fragment>
                {this.props.selectedId !== null && this.props.selectedId.name === 'Length' && !this.props.userInput ? (
                    <Fragment></Fragment>
                ) : (
                    <Fragment>
                        <div
                            className="icon-minus"
                            onClick={() => {
                                if (this.props.selectedId === null) {
                                    this.props.delete();
                                }
                                if (this.props.selectedId !== null && this.props.selectedId.name !== 'Length') {
                                    this.props.delete();
                                }
                            }}
                        >
                            <MinusCircleOutlined />
                        </div>
                        <Select
                            defaultValue={this.props.selectedId === null ? null : this.props.selectedId.name}
                            onChange={(customFieldId) => {
                                const name = this.props.allCustomFields[customFieldId].name;

                                this.props.setSelected(customFieldId, this.props.selectedId, name);
                            }}
                            disabled={this.props.selectedId !== null && this.props.selectedId.name === 'Length'}
                        >
                            {Object.values(this.props.allCustomFields).map(
                                (customField) =>
                                    customField.name !== 'Length' && (
                                        <React.Fragment>
                                            <Option key={customField.id} value={customField.id}>
                                                {customField.name}
                                            </Option>
                                        </React.Fragment>
                                    )
                            )}
                        </Select>
                        <Radio.Group
                            buttonStyle="solid"
                            defaultValue={this.props.required}
                            onChange={(e) => this.props.setRequired(e.target.value)}
                            disabled={this.props.selectedId !== null && this.props.selectedId.name === 'Length'}
                        >
                            <Tooltip placement="top" title="Must be set before running test plan">
                                <Radio.Button value={true}>Required</Radio.Button>
                            </Tooltip>
                            <Tooltip placement="top" title="Optional field">
                                <Radio.Button value={false}>Not Required</Radio.Button>
                            </Tooltip>
                        </Radio.Group>

                        <div>
                            <Tooltip placement="top" title="Field will be cleared when focused">
                                <Checkbox
                                    checked={this.props.autoClear}
                                    onChange={(e) => this.props.setAuto(e.target.checked, 1)}
                                >
                                    Auto-Clear
                                </Checkbox>
                            </Tooltip>
                            <Tooltip
                                placement="top"
                                title="Field will be appended with '-1' and increment automatically for each DUT tested"
                            >
                                <Checkbox
                                    checked={this.props.autoIncrement}
                                    onChange={(e) => this.props.setAuto(e.target.checked, 2)}
                                >
                                    Auto-Increment
                                </Checkbox>
                            </Tooltip>
                        </div>
                        <div>
                            {this.state.showCustomFieldsTooltip && (
                                <div className="tooltip">Required: Must be set before running Test Plan</div>
                            )}
                        </div>
                    </Fragment>
                )}
            </Fragment>
        );
    }
}